export enum ECommissionSchemeType {
  REFERRED = 'REFERRED',
  AFFILIATED = 'AFFILIATED'
}
